import * as React from 'react';
import { ReviewSnippet } from '@grandvisionhq/reviews';
import { getAttrValue } from '@grandvisionhq/utils';
import { useProductDetailContext } from '../../../Context/ProductDetailContext.js';

const LensesStarReview = ({ className  })=>{
    const { product: { masterVariant  } ,  } = useProductDetailContext();
    const variantGroup = String(getAttrValue(masterVariant, 'brandKey'));
    return /*#__PURE__*/ React.createElement(ReviewSnippet, {
        className: className,
        productId: variantGroup
    });
};

export { LensesStarReview };
//# sourceMappingURL=LensesStarReview.js.map
